import React from "react";
import Marquee from "react-fast-marquee";

const Partners = () => {
  return (
    <div className=" py-7 bg-[#fff] w-[90%] mx-auto">
      <h1 className="text-[50px] text-red-600 mr-4">Our Partners</h1>

      {/* <div className="grid grid-cols-2"> */}
      <Marquee speed={100} className="z-0">
        <img src="/petrocam.png" alt="PetroCam Logo" className=" ml-8" />
        <img src="/lpgar.jpg" alt="" className="h-[200px]  ml-8" />
        <img src="/wasteswap.jpg" alt="" className="h-[200px]  ml-8" />
        <img src="/peaking.jpg" alt="" className="h-[200px]  ml-8" />
      </Marquee>
      {/* </div> */}
    </div>
  );
};

export default Partners;
